module.exports = __webpack_public_path__ + "img/page-headline.f47a6ab3.jpg";